import { useEffect, useState } from "react";

export const TableOfContents = ({ headings }) => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const els = headings.map((h) => document.getElementById(h.id)).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-80px 0px -70% 0px" },
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [headings]);

  const go = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", `#${id}`);
    setActive(id);
  };

  if (!headings.length) return null;

  return (
    <nav data-testid="doc-toc" className="space-y-1 text-xs">
      <p className="mb-3 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Na ovoj stranici</p>
      {headings.map((h) => (
        <a
          key={h.id}
          href={`#${h.id}`}
          onClick={(e) => go(e, h.id)}
          data-testid={`toc-link-${h.id}`}
          className={`block border-l py-1 leading-snug transition-colors ${h.depth === 3 ? "pl-6" : "pl-3"} ${
            active === h.id ? "border-primary text-foreground" : "border-border text-muted-foreground hover:text-foreground"
          }`}
        >
          {h.text}
        </a>
      ))}
    </nav>
  );
};
